<template>
  <div id="mypage_menu">
    <div @click="toggleMenu" id="menu" v-bind:class="{ menuopen: open }">
      <span class="nav-icon-box">
        <!-- ユーザアイコン  -->
        <span v-show="loading">
          <vue-loading
            style="display: inline-block; _display: inline"
            type="spin"
            color="#333"
            :size="{ width: '30px', height: '30px' }"
          ></vue-loading>
        </span>
        <span v-show="!loading">
          <img
            class="small_noicon"
            v-if="!user.icon_name"
            :src="mediaportalResourceUrl + '/community/img/noimg_man@3x.png'"
          />
          <img v-else class="rounded-circle small_icon" :src="user.icon_url" />
          <img
            v-if="countNotifications"
            :src="mediaportalResourceUrl + '/community/img/yellow_circle.png'"
            class="nav-notification"
          />
        </span>
      </span>
      <span class="nav_item small-font">認定プランナー</span>
    </div>
    <div
      id="mypage_background"
      @click="toggleMenu"
      :class="{ background_open: open }"
    ></div>
    <div
      class="justify-content-center"
      id="mypage_wrapper"
      :class="{ list_open: open }"
    >
      <div class="planner" id="mypage_list">
        <div class="card">
          <div class="card-header position-relative">
            <span id="mypage_close_button">
              <img
                style="cursor: pointer"
                :src="
                  mediaportalResourceUrl + '/community/img/btn_close_white.png'
                "
                @click="toggleMenu"
              />
            </span>
            <span> マイページ </span>
          </div>

          <div class="card-body p-4">
            <div>
              <vue-loading
                v-show="loading"
                type="spin"
                color="#333"
                :size="{ width: '100px', height: '100px' }"
              ></vue-loading>
            </div>
            <div v-show="!loading" class="row">
              <div class="container-fluid pr-0 pl-0">
                <div class="row w-100">
                  <div class="col-5 text-center p-0">
                    <img
                      v-if="!user.icon_name"
                      :src="
                        mediaportalResourceUrl +
                        '/community/img/noimg_man@3x.png'
                      "
                      class="middle_noicon"
                      alt="mypage"
                    />
                    <img
                      v-else
                      id="nav_icon"
                      class="nav_item middle_icon"
                      :src="user.icon_url"
                    />
                    <br />

                    <span class="mt-1 font-weight-bold">{{
                      user.nickname
                    }}</span
                    ><br />
                    ({{ user.ID }})<br />
                    <!-- regionがnullableの場合 -->
                    <div style="margin-top: 0.5rem">プランナー</div>
                  </div>
                  <div class="col-7 text-left">
                    <table
                      class="ml-auto mr-auto followbox w-100"
                      style="table-layout: fixed"
                    >
                      <tr>
                        <td class="p-1 pl-2">
                          <small class="ml-2">フォロワー</small> <br />
                          <span class="ml-1"
                            ><img
                              :src="
                                mediaportalResourceUrl +
                                '/community/img/icon_follower@3x.png'
                              "
                              class="extra_small_icon"
                              alt="follower"
                          /></span>
                          &nbsp;{{ follower }}
                        </td>
                        <td style="width: 1vw">&nbsp;</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="text-left">
                          {{ profile.introduction || "" }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="text-center container-fluid pr-0 pl-0 mt-4">
              <div class="row w-100">
                <div
                  class="card mr-auto pr-auto p-1 small-font pb-2"
                  style="width: 49%"
                >
                  <table style="table-layout: fixed">
                    <tr>
                      <td>
                        <div class="icon-text mb-1">
                          <b class="align-bottom brown-font">企業名</b>
                        </div>
                      </td>
                    </tr>
                    <tr v-show="profile.working_place">
                      <td>{{ profile.working_place }}</td>
                    </tr>
                  </table>
                </div>
                <div class="card p-1 small-font pb-2" style="width: 49%">
                  <table>
                    <tr>
                      <td>
                        <div class="icon-text mb-1">
                          <b class="align-bottom brown-font">主な担当会場</b>
                        </div>
                      </td>
                    </tr>
                    <tr v-show="profile.working_hall">
                      <td>{{ profile.working_hall_text }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="mt-2 p-0">
              <div class="areas row w-100">
                <div class="card col-12 p-2">
                  <b class="brown-font text-center small-font mb-1"
                    >主な担当エリア</b
                  >
                  <ul class="text-center p-0 inline small-font mb-1">
                    <li
                      class="list-unstyled"
                      v-for="area in areas"
                      :key="area.text"
                    >
                      {{ area.text }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <a
              :href="
                communicationUrl + `/user/${user.ID}/notifications?from=blog`
              "
              style="color: #333333; text-decoration: none"
            >
              <div
                class="card text-center mt-2 bg-brown notification-link align-middle"
              >
                <span
                  v-show="countNotifications > 0"
                  class="circle-notification yellow-mark"
                >
                  {{ countNotifications }}
                </span>
                <span class="text white-text">お知らせ</span>
              </div>
            </a>

            <div class="card mt-4">
              <table
                class="table table-light text-center ml-auto mr-auto latticle-brown"
              >
                <tr>
                  <td>
                    <a
                      :href="
                        communicationUrl +
                        `/planner/edit_profile/step5?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon1_brown.png'
                        "
                        alt="profile"
                        class="mypage_icon"
                      /><br />プロフィール<br />編集</a
                    >
                  </td>
                  <td>
                    <a
                      :href="
                        communicationUrl + `/user/${user.ID}/my_bbs?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon4_brown.png'
                        "
                        alt="myStory"
                        class="mypage_icon"
                      /><br />あなたの<br />掲示板</a
                    >
                  </td>
                </tr>
                <tr>
                  <td>
                    <a
                      :href="
                        communicationUrl +
                        `/planner/${user.ID}/my_followers?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon6_brown.png'
                        "
                        alt="myGallery"
                        class="mypage_icon"
                      /><br />フォロワー<br />一覧</a
                    >
                  </td>
                  <td>
                    <a
                      :href="
                        communicationUrl +
                        `/planner/${user.ID}/change_password?from=blog`
                      "
                      style="color: #333333"
                      ><img
                        :src="
                          mediaportalResourceUrl +
                          '/community/img/maypage_icon7_brown.png'
                        "
                        alt="myQuestion"
                        class="mypage_icon"
                      /><br />パスワード<br />変更</a
                    >
                  </td>
                </tr>
              </table>
            </div>
            <div class="w-80 ml-auto mr-auto">
              <button
                @click="openModal"
                class="text-center mt-4 p-2 col-12 border-text-brown"
              >
                ログアウト
              </button>
            </div>

            <!-- コンポーネント MyModal -->
            <LogoutModal @close="closeModal" v-if="modal">
              <!-- default スロットコンテンツ -->
              <p class="mypage_logout_message">ログアウトしますか？</p>
              <button class="mypage_logout_button" @click="logout">
                ログアウトする
              </button>
              <!-- /default -->
              <!-- footer スロットコンテンツ -->
              <template slot="footer"> </template>
              <!-- /footer -->
            </LogoutModal>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LogoutModal from "./LogoutModal.vue";
import { VueLoading } from "vue-loading-template";
import axios from "axios";

export default {
  beforeDestroy() {
    document.body.className = "";
    this.$root.headerHide = false;
    this.$root.footerHide = false;
  },
  components: {
    LogoutModal,
    VueLoading,
  },
  computed: {
    communicationUrl: function () {
      return process.env.VUE_APP_BASE_COMMUNICATION_URL;
    },
    mediaportalResourceUrl: function () {
      return (
        process.env.VUE_APP_BASE_MEDIAPORTAL_URL +
        process.env.VUE_APP_MEDIAPORTAL_RESOURCE_URI
      );
    },
  },
  data() {
    return {
      open: false,
      follower: "",
      following: "",
      //profile
      user: {},
      profile: {},
      areas: {},

      separate: "",
      countNotifications: 0,
      modal: false,
      loading: true,
    };
  },
  mounted() {
    //ユーザのフォロー、フォロワー数の取得
    axios
      .get(process.env.VUE_APP_BASE_COMMUNICATION_URL + "/api/follows_count")
      .then((response) => {
        this.following = response.data.follow;
        this.follower = response.data.followed;
      });
    //ユーザのプロフィール情報の取得
    axios
      .get(process.env.VUE_APP_BASE_COMMUNICATION_URL + "/api/mypage", {
        timeout: 30000,
      })
      .then((response) => {
        this.profile = response.data.profile;
        this.user = response.data.user;
        this.areas = response.data.areas;
        this.current_step = response.data.current_step;
        this.completed = response.data.completed;
        this.loading = false;
      });
    //通知件数の取得
    axios
      .get(this.communicationUrl + "/api/countNotifications")
      .then((response) => (this.countNotifications = response.data));

    this.separate = "|";

    this.user.icon_url =
      this.communicationUrl + "/community/img/noimg_man@2x.png";
  },
  methods: {
    async toggleMenu() {
      var bg = document.getElementById("mypage_background");
      var wrapper = document.getElementById("mypage_wrapper");
      // var main = document.getElementsByTagName("main")[0];
      // var footer = document.getElementsByTagName("footer")[0];

      if (!bg.classList.contains("background_open")) {
        this.offset = window.pageYOffset;
        // main.style.top = -this.offset + "px";
        // footer.style.top = -(this.offset - main.scrollHeight) + "px";
        bg.style.display = "block";
        wrapper.style.display = "block";
        wrapper.style.height = "100vh";
        wrapper.style.overflowY = "scroll";
        // main.style.position = "fixed";
        // footer.style.position = "fixed";
        // this.$store.commit("path/setPath", this.$route.path);

        // 開くアニメーションのため時間差実行
        setTimeout(function () {
          bg.classList.add("background_open");
          wrapper.classList.add("list_open");
          //                    this.open = true; // 時間差実行だとvueのopen変数が何故かtrueとならないため不採用
        }, 1);
      } else {
        bg.classList.remove("background_open");
        wrapper.classList.remove("list_open");
        bg.style.display = "none";
        wrapper.style.display = "none";
        // main.style.position = "static";
        // footer.style.position = "static";
        document.documentElement.scrollTop = this.offset;
        //                    this.open = false
      }
    },
    openModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    async logout() {
      await this.$store.dispatch("auth/logout");
      // ログアウト後にページリロード
      window.location.href = this.communicationUrl + "/user/sign_in";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PlannerMypage.vue